module.exports = __webpack_public_path__ + "static/media/Impreza-Hawk-GD-Sedan.08b22c1f.jpg";